import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Calendar, Users, MapPin, Heart, Cake, Music, Camera, Diamond } from 'lucide-react';

const BookWedding = () => {
  const [selectedPackage, setSelectedPackage] = useState('basic');

  const packages = [
    { 
      id: 'basic', 
      name: 'Basic Wedding', 
      price: '₹2,50,000', 
      features: ['Venue Decoration', 'Catering for 100', 'Basic Photography'] 
    },
    { 
      id: 'premium', 
      name: 'Premium Wedding', 
      price: '₹5,00,000', 
      features: ['Full Venue Setup', 'Premium Catering', 'Professional Photography', 'Entertainment'] 
    },
    { 
      id: 'royal', 
      name: 'Royal Wedding', 
      price: '₹10,00,000+', 
      features: ['Luxury Venue', '5-Star Catering', 'Videography', 'Live Band', 'Fireworks'] 
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-rose-50">
      <Navbar />
      
      <div className="pt-24 pb-20 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center p-4 bg-gradient-to-r from-pink-100 to-rose-100 rounded-2xl mb-6">
              <Diamond className="h-12 w-12 text-pink-500" />
              <Heart className="h-10 w-10 text-rose-500 -ml-4" />
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent">
              Plan Your Dream Wedding
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Let us create the perfect wedding celebration that reflects your love story
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-2xl">
            <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">
              Wedding Planning Form
            </h2>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Heart className="h-4 w-4 mr-2 text-pink-500" />
                    Couple's Names
                  </label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all"
                    placeholder="John & Jane" 
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Calendar className="h-4 w-4 mr-2 text-pink-500" />
                    Wedding Date
                  </label>
                  <input 
                    type="date" 
                    className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Users className="h-4 w-4 mr-2 text-pink-500" />
                    Guest Count
                  </label>
                  <input 
                    type="number" 
                    className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all"
                    placeholder="Number of guests" 
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Diamond className="h-4 w-4 mr-2 text-pink-500" />
                    Budget Range
                  </label>
                  <select className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all">
                    <option value="">Select budget range</option>
                    <option value="2-5">₹2-5 Lakhs</option>
                    <option value="5-10">₹5-10 Lakhs</option>
                    <option value="10+">₹10 Lakhs+</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-gray-700 mb-2">Wedding Theme/Vision</label>
                <textarea 
                  rows="4" 
                  className="w-full px-4 py-3 rounded-xl border border-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all"
                  placeholder="Describe your dream wedding theme, colors, style preferences..."
                ></textarea>
              </div>

              <div>
                <label className="block text-gray-700 mb-4 text-xl font-semibold">Select Package</label>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {packages.map(pkg => (
                    <div 
                      key={pkg.id} 
                      className={`p-6 rounded-2xl border-2 cursor-pointer transition-all duration-300 transform hover:-translate-y-1 ${
                        selectedPackage === pkg.id 
                          ? 'border-pink-500 bg-gradient-to-b from-pink-50 to-rose-50 shadow-lg' 
                          : 'border-pink-200 hover:border-pink-400'
                      }`}
                      onClick={() => setSelectedPackage(pkg.id)}
                    >
                      <h3 className="text-xl font-bold mb-2 text-gray-800">{pkg.name}</h3>
                      <div className="text-2xl font-bold text-pink-600 mb-4">{pkg.price}</div>
                      <ul className="space-y-2">
                        {pkg.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center text-gray-600">
                            <Heart className="h-4 w-4 mr-2 text-pink-500" />
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <div className="mt-6 text-center">
                        <button 
                          type="button"
                          className={`px-6 py-2 rounded-full font-semibold ${
                            selectedPackage === pkg.id
                              ? 'bg-gradient-to-r from-pink-500 to-rose-500 text-white'
                              : 'bg-pink-100 text-pink-700'
                          }`}
                        >
                          Select Package
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="pt-6 border-t border-pink-100">
                <label className="block text-gray-700 mb-4 text-xl font-semibold">Additional Services (Optional)</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <label className="flex items-center space-x-3 p-4 border border-pink-200 rounded-xl cursor-pointer hover:bg-pink-50">
                    <input type="checkbox" className="h-5 w-5 text-pink-500" />
                    <div className="flex items-center">
                      <Music className="h-5 w-5 mr-2 text-pink-500" />
                      <span>Live Music/Band</span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-4 border border-pink-200 rounded-xl cursor-pointer hover:bg-pink-50">
                    <input type="checkbox" className="h-5 w-5 text-pink-500" />
                    <div className="flex items-center">
                      <Camera className="h-5 w-5 mr-2 text-pink-500" />
                      <span>Professional Videography</span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-4 border border-pink-200 rounded-xl cursor-pointer hover:bg-pink-50">
                    <input type="checkbox" className="h-5 w-5 text-pink-500" />
                    <div className="flex items-center">
                      <Cake className="h-5 w-5 mr-2 text-pink-500" />
                      <span>Custom Wedding Cake</span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-4 border border-pink-200 rounded-xl cursor-pointer hover:bg-pink-50">
                    <input type="checkbox" className="h-5 w-5 text-pink-500" />
                    <div className="flex items-center">
                      <MapPin className="h-5 w-5 mr-2 text-pink-500" />
                      <span>Destination Wedding Planning</span>
                    </div>
                  </label>
                </div>
              </div>

              <button 
                type="submit" 
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold text-xl rounded-xl hover:shadow-xl hover:shadow-pink-200 transform hover:-translate-y-1 transition-all duration-300"
              >
                Submit Wedding Inquiry
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="mt-12 bg-gradient-to-r from-pink-500 to-rose-500 rounded-3xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Need Immediate Assistance?</h3>
            <p className="mb-6 text-pink-100">Our wedding specialists are available 24/7</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-6 py-3 bg-white text-pink-600 font-bold rounded-full hover:bg-pink-50 transition-all">
                Call Now: +91 98765 43210
              </button>
              <button className="px-6 py-3 bg-transparent border-2 border-white text-white font-bold rounded-full hover:bg-white/10 transition-all">
                Schedule Video Call
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BookWedding;